import { DetailedHTMLProps, HTMLAttributes } from 'react';
import './index.less';

export interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  justify?:
    | 'space-between'
    | 'left'
    | 'right'
    | 'justify-center'
    | 'justify-start'
    | 'justify-end'
    | 'space-around';
  align?: 'center' | 'top' | 'bottom' | 'stretch' | 'start';
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse' | 'inherit';
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  flexType?: 'default' | 'inline-flex';
  className?: string;
  style?: object;
  alignSelf?:
    | 'align-self-auto'
    | 'align-self-normal'
    | 'align-self-stretch'
    | 'align-self-center'
    | 'align-self-start'
    | 'align-self-end'
    | 'align-self-flex-start'
    | 'align-self-flex-end'
    | 'unset';
}

const RevxFlexLayout = ({
  justify = 'left',
  align = 'center',
  direction = 'row',
  wrap = 'nowrap',
  flexType = 'default',
  alignSelf = 'unset',
  className = '',
  style,
  ...props
}: Props) => {
  return (
    <div
      className={`revx-flexlayout ${justify} ${align} ${wrap} ${direction} ${alignSelf} ${flexType} ${className}`}
      style={style}
      {...props}
    >
      {props.children}
    </div>
  );
};

export default RevxFlexLayout;
